<template>
  <div class="privacy-page">
    <div class="privacy-container">
      <div class="privacy-header">
        <router-link to="/login" class="back-btn">
          <i class="fas fa-arrow-left"></i>
          返回登录
        </router-link>
        <h1>隐私政策</h1>
      </div>
      
      <div class="privacy-content">
        <div class="content-section">
          <h2>1. 信息收集</h2>
          <p>我们会收集您主动提供的信息，包括但不限于：</p>
          <ul>
            <li>注册时提供的邮箱地址</li>
            <li>使用服务时产生的搜索记录</li>
            <li>设备信息和使用统计数据</li>
          </ul>
        </div>

        <div class="content-section">
          <h2>2. 信息使用</h2>
          <p>我们使用收集的信息用于：</p>
          <ul>
            <li>提供和改进我们的服务</li>
            <li>个性化用户体验</li>
            <li>发送重要通知和更新</li>
            <li>分析服务使用情况</li>
          </ul>
        </div>

        <div class="content-section">
          <h2>3. 信息保护</h2>
          <p>我们采取以下措施保护您的个人信息：</p>
          <ul>
            <li>使用业界标准的加密技术</li>
            <li>限制员工访问个人信息</li>
            <li>定期进行安全审核</li>
            <li>遵守相关法律法规</li>
          </ul>
        </div>

        <div class="content-section">
          <h2>4. 信息共享</h2>
          <p>除以下情况外，我们不会与第三方共享您的个人信息：</p>
          <ul>
            <li>获得您的明确同意</li>
            <li>法律要求或政府要求</li>
            <li>保护我们的合法权益</li>
            <li>与可信的服务提供商合作</li>
          </ul>
        </div>

        <div class="content-section">
          <h2>5. Cookie 使用</h2>
          <p>我们使用 Cookie 和类似技术来：</p>
          <ul>
            <li>记住您的登录状态</li>
            <li>分析网站流量</li>
            <li>改善用户体验</li>
            <li>提供个性化内容</li>
          </ul>
        </div>

        <div class="content-section">
          <h2>6. 用户权利</h2>
          <p>您享有以下权利：</p>
          <ul>
            <li>访问您的个人信息</li>
            <li>更正不准确的信息</li>
            <li>删除您的个人信息</li>
            <li>限制信息处理</li>
            <li>数据可移植性</li>
          </ul>
        </div>

        <div class="content-section">
          <h2>7. 政策更新</h2>
          <p>我们可能会不时更新本隐私政策。重大变更将通过以下方式通知您：</p>
          <ul>
            <li>在网站上发布通知</li>
            <li>发送电子邮件通知</li>
            <li>应用内通知</li>
          </ul>
        </div>

        <div class="content-section">
          <h2>8. 联系我们</h2>
          <p>如果您对本隐私政策有任何疑问或建议，请通过以下方式联系我们：</p>
          <div class="contact-info">
            <p><strong>邮箱：</strong> privacy@cloudsway.ai</p>
            <p><strong>地址：</strong> 中国上海市浦东新区</p>
            <p><strong>电话：</strong> +86-21-1234-5678</p>
          </div>
        </div>

        <div class="policy-footer">
          <p><strong>最后更新时间：</strong> {{ lastUpdated }}</p>
          <p><strong>生效时间：</strong> {{ effectiveDate }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'Privacy',
  setup() {
    const lastUpdated = ref('2024年1月1日')
    const effectiveDate = ref('2024年1月1日')

    return {
      lastUpdated,
      effectiveDate
    }
  }
}
</script>

<style lang="scss" scoped>
.privacy-page {
  min-height: 100vh;
  background-color: #f9fafb;
  padding: 20px;
}

.privacy-container {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.privacy-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px 32px;
  position: relative;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: white;
  text-decoration: none;
  font-size: 14px;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  i {
    font-size: 12px;
  }
}

.privacy-header h1 {
  font-size: 28px;
  font-weight: 500;
  margin: 0;
}

.privacy-content {
  padding: 32px;
  line-height: 1.6;
  color: #374151;
}

.content-section {
  margin-bottom: 32px;

  h2 {
    color: #1f2937;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid #e5e7eb;
  }

  p {
    margin-bottom: 12px;
    font-size: 16px;
  }

  ul {
    margin: 12px 0;
    padding-left: 20px;

    li {
      margin-bottom: 8px;
      font-size: 15px;
    }
  }
}

.contact-info {
  background: #f3f4f6;
  padding: 20px;
  border-radius: 8px;
  margin-top: 16px;

  p {
    margin-bottom: 8px;
    font-size: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    color: #1f2937;
  }
}

.policy-footer {
  background: #f9fafb;
  padding: 20px;
  border-radius: 8px;
  margin-top: 32px;
  border-top: 1px solid #e5e7eb;

  p {
    margin-bottom: 8px;
    font-size: 14px;
    color: #6b7280;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    color: #374151;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .privacy-page {
    padding: 10px;
  }

  .privacy-header {
    padding: 20px 24px;

    h1 {
      font-size: 24px;
    }
  }

  .privacy-content {
    padding: 24px 20px;
  }

  .content-section {
    h2 {
      font-size: 18px;
    }

    p {
      font-size: 15px;
    }

    ul li {
      font-size: 14px;
    }
  }
}

@media (max-width: 480px) {
  .privacy-header {
    padding: 16px 20px;

    h1 {
      font-size: 22px;
    }
  }

  .privacy-content {
    padding: 20px 16px;
  }

  .back-btn {
    font-size: 13px;
    padding: 6px 10px;
  }
}
</style>